import { render, staticRenderFns } from "./TypingEssayTestReview.vue?vue&type=template&id=48f41f49&scoped=true&"
import script from "./TypingEssayTestReview.vue?vue&type=script&lang=js&"
export * from "./TypingEssayTestReview.vue?vue&type=script&lang=js&"
import style0 from "./TypingEssayTestReview.vue?vue&type=style&index=0&id=48f41f49&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f41f49",
  null
  
)

export default component.exports